export default __webpack_public_path__ + "static/media/doll.beeb65e5.svg";